import { remark } from "remark";
import remarkHtml from "remark-html";

import rehypeParse from "rehype-parse";
import rehypeRemark from "rehype-remark";

export function markdownToHtml(markdownText: string) {
    const normalizedMarkdown = markdownText
        .replace(/\s{3,}/g, ' ') // Убираем лишние пробелы
        .replace(/\n/g, '\n\n');
    const file = remark()
        .use(remarkHtml)
        .processSync(normalizedMarkdown);

    return String(file);
}

export function htmlToMarkdown(htmlText: string) {
    const file = remark()
        .use(rehypeParse, { emitParseErrors: true, duplicateAttribute: false })
        .use(rehypeRemark)
        .processSync(htmlText);

    return String(file);
}
